import { useState } from "react";
import { Check, Copy } from "lucide-react";

export function CopyConnect({ code }) {
  const [copied, setCopied] = useState(false);
  const text = `connect ${code}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <button
      type="button"
      onClick={copy}
      className={`inline-flex items-center gap-1.5 rounded-sm border px-1.5 py-0.5 font-mono text-xs transition-colors duration-200 ${copied ? "border-emerald-500/60 bg-emerald-500/10 text-emerald-300" : "border-eden-border bg-eden-surface text-eden-text hover:border-eden-orange"}`}
      aria-label={copied ? "Copiado" : `Copiar ${text}`}
      aria-live="polite"
      title="Copiar"
      data-testid="copy-connect-button"
    >
      {copied ? <Check size={12} aria-hidden="true" /> : <Copy size={12} aria-hidden="true" />}
      {copied ? "Copiado" : text}
    </button>
  );
}
